import classNames from 'classnames';
import React from 'react';

import './PhoneCountryCode.scss';
import { Menu } from '../Menu';

export interface PhoneCountryCodeValue {
  countryCode: string;
  dialCode: string;
  flag: string;
}
export interface PhoneCountryCodeProps {
  defaultValue: PhoneCountryCodeValue;
  children?: React.ReactNode;
  'data-testid'?: string;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  id?: string;
}
const PhoneCountryCode = React.forwardRef(
  (
    {
      id,
      children,
      className,
      defaultValue,
      disabled,
      error,
      ...otherProps
    }: PhoneCountryCodeProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div className="flex flex-col" id={id}>
        <div
          className={classNames(
            'Mfw-PhoneCountryCode-root',
            {
              'Mfw-PhoneCountryCode-root--has-error': error,
            },
            className,
          )}
          tabIndex={disabled ? -1 : 0}
          ref={ref}
          {...otherProps}
        >
          {defaultValue.flag} {defaultValue.dialCode}
        </div>
        {error && <div className="Mfw-PhoneCountryCode__error w-full" />}
      </div>
    );
  },
);

PhoneCountryCode.displayName = 'PhoneCountryCode';

const PhoneCountryCodeWrapper = Menu<PhoneCountryCodeProps>(PhoneCountryCode);

export default PhoneCountryCodeWrapper;
